/**
 * Base fields whose dropdown options are raw users (IUser) rather than a custom
 * list. Keep in sync with the user cases of `getDropdownOptionList` in ./utils.
 */
export const USER_BASE_FIELDS = ['assignedTo', 'createdBy', 'receivedBy', 'approvedBy'] as const;

/**
 * OBD-870 for base-field user dropdowns.
 *
 * These options are raw `IUser` objects with a TOP-LEVEL `enabled` flag (no
 * `userValue`), so the custom-list filter (`filterUserEnabledOptions`) cannot
 * cover them. Mirror the same rule here: show enabled users only, but keep the
 * currently-selected user visible even if disabled — so an already-assigned but
 * now-disabled user stays visible and can be changed away from, yet is the only
 * disabled option shown and therefore cannot be re-selected once deselected.
 *
 * No-op for any field that is not a user base field, so other base dropdowns
 * (record type, status, problem code) are left untouched.
 */
export const filterEnabledUserOptions = <T extends { id: string | number; enabled?: boolean }>(
    fieldName: string,
    options: T[],
    selectedId?: string
): T[] => {
    if (!(USER_BASE_FIELDS as ReadonlyArray<string>).includes(fieldName)) return options;
    return options.filter((opt) => opt.enabled === true || String(opt.id) === selectedId);
};
